import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Mail, MapPin, Phone } from 'lucide-react';
import './Contact.css';

const contactItems = [
  {
    icon: Mail,
    label: 'Email',
    value: 'contactankurit@gmail.com',
  },
  {
    icon: Phone,
    label: 'Phone',
    value: '+91 98765 43210',
  },
  {
    icon: MapPin,
    label: 'Based in',
    value: 'India',
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const formRef = useRef();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    emailjs
      .sendForm('service_cwdlh15', 'template_4lq63ds', formRef.current, 'rAwYRak98_50PGxEN')
      .then(() => {
        alert('Thank you for your message. We will get back to you soon.');
        setFormData({ name: '', email: '', message: '' });
      })
      .catch((error) => {
        console.error('Email sending failed:', error);
        alert('Something went wrong. Please try again later.');
      });
  };

  return (
    <section className="ankurit-contact" id="contact">
      <div className="ankurit-contact__intro">
        <span>Contact</span>
        <h2>Bring your nursery, farm, or buying team onto Ankurit.</h2>
      </div>

      <div className="ankurit-contact__layout">
        <div className="ankurit-contact__details">
          {contactItems.map(({ icon: Icon, label, value }) => (
            <div className="ankurit-contact__item" key={label}>
              <Icon size={20} />
              <div>
                <span>{label}</span>
                <p>{value}</p>
              </div>
            </div>
          ))}
        </div>

        <form ref={formRef} className="ankurit-contact__form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            required
          />
          <button type="submit" className="ankurit-contact__submit">
            Send message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
